import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthBagService } from '@/auth/auth-bag.service';
import { AuthService } from '@/auth/auth.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
	constructor(
		private readonly authBagService: AuthBagService,
		private readonly auth: AuthService,
	) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		let headers = request.headers;

		if (
			typeof this.auth.token2Get() !== 'undefined' &&
			!headers.get('Authorization') &&
			request.url.includes(environment.erpUrl)
		) {
			headers = headers.set('Authorization', this.auth.token2Get());
		}

		if (
			(this.authBagService.tokenGet() &&
				!headers.get('Authorization') &&
				request.url.includes(environment.apiUrl)) ||
			//symfony uses the same auth header as BAG
			request.url.includes(environment.erpSymfonyUrl)
		) {
			headers = headers.set('Authorization', `Bearer ${this.authBagService.tokenGet()}`);
		}

		headers = headers.set('Accept', '*/*');

		const authReq = request.clone({ headers });

		return next.handle(authReq);
	}
}
